import * as React from 'react';
import styled, { css } from 'styled-components';
import { themeGet } from '@styled-system/theme-get';
import { space } from 'styled-system';

const SVG = (props) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 56 56"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <g clipPath="url(#Thinking_face_Color_56_svg__clip0)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M28 6C15.85 6 6 15.85 6 28c0 1.721.197 3.395.57 5a3.09 3.09 0 012.994 2.095c.3 1.2.8 2.7 1.2 3.8 1.5-1.1 3.7-1.9 6.6-2.4 1.052-.21 2.743-.372 4.281-.518a122.74 122.74 0 001.819-.182c1.6-.1 3.1 1 3.3 2.6.2 1.7-.9 3.3-2.9 3.5l-.9.1c1.1.5 1.8 1.7 1.5 2.9-.2 1.1-1.2 1.9-2.3 2 .547.638.595 1.61.22 2.382A22.04 22.04 0 0028 50c12.15 0 22-9.85 22-22S40.15 6 28 6zM4 28c0 1.98.24 3.904.692 5.746a2.901 2.901 0 00-.828 2.849c.1.35.175.725.25 1.1.075.375.15.75.25 1.1.3 1.2.3 1.9.3 2.4 0 .253-.08.466-.165.69-.049.13-.099.263-.135.41l-.076.148c-.193.376-.436.848-.524 1.552-.1.8 0 1.8.2 3.1.5 2.5 2.4 3.7 4.2 4.2 1.29.359 2.684.409 3.701.445.401.014.744.027.999.055.7 0 1.3.3 2.1.8.7.4 1.8 1 3 .4.7-.3 1.2-.8 1.4-1.4.186-.373.199-.747.2-1.12A23.949 23.949 0 0028 52c13.255 0 24-10.745 24-24S41.255 4 28 4 4 14.745 4 28zm5.364 12.995c.1.3.4.5.7.6.3.1.7 0 .9-.3 1.2-1.2 3.3-2.3 6.8-2.8 1.066-.228 2.827-.399 4.446-.555.507-.05 1-.097 1.454-.145.5 0 1 .3 1.1.9.1.6-.3 1.1-.9 1.2l-6.7 1c-.5.1-.8.5-.9 1 0 .5.3.9.8 1l5.2 1c.3.1.5.3.4.6-.1.3-.3.4-.5.4l-3.1-.3c-.5 0-.9.2-1 .6-.2.4 0 .9.3 1.2l2.4 1.6c.1.1.2.3.1.4-.1.1-.2.1-.3.1l-1.8-.7c-.4-.2-.8-.1-1.1.2-.3.3-.3.8-.2 1.1 0 0 .7 1.1.3 1.6-.4.6-.9.4-1.7 0l-.075-.043c-.696-.398-1.671-.957-2.925-.957-1.2 0-2.8 0-4.3-.4-1.4-.4-2.5-1.1-2.8-2.6-.2-1.2-.2-2-.2-2.5.1-.5.2-.8.4-1.2.2-.4.4-1 .5-1.8.1-.8 0-1.7-.4-3.1-.1-.5-.3-1.3-.5-1.9-.1-.5.2-1 .7-1.2.5-.1 1 .1 1.2.6.5 1.9 1.3 4.5 1.7 5.4zm6.792-11.812a1 1 0 01-.312-1.976l.156.988-.156-.988h.006l.013-.003.045-.006.162-.022c.14-.018.34-.042.593-.066.508-.048 1.23-.098 2.102-.108 1.74-.02 4.105.117 6.569.76 2.464.642 4.776 1.753 6.457 2.689.844.47 1.537.9 2.022 1.216a25.93 25.93 0 01.715.481l.04.03.012.008.004.002s.001.001-.52.722l.52-.721a1 1 0 01-1.17 1.622l-.007-.006-.032-.022-.132-.092a32.982 32.982 0 00-2.425-1.493c-1.604-.893-3.751-1.918-5.99-2.502-2.238-.584-4.414-.713-6.04-.694a23.7 23.7 0 00-1.936.1 16.234 16.234 0 00-.66.075l-.03.005h-.006zm17.897-12.236a1 1 0 011 1v3.158a1 1 0 11-2 0v-3.158a1 1 0 011-1zm-13.527-.894a1 1 0 10-2 0v3.157a1 1 0 102 0v-3.157z"
        fill="#000"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M43.003 33.28a2.5 2.5 0 01-4.99.323l2.495-.17c-2.494.17-2.495.167-2.495.167v-.02l-.003-.034a8.978 8.978 0 01-.01-.403c0-.25.008-.594.041-1 .067-.8.24-1.918.686-3.076.449-1.163 1.212-2.458 2.51-3.462C42.563 24.58 44.267 24 46.33 24c1.997 0 4.01.636 5.556 2.01 1.587 1.41 2.512 3.449 2.512 5.862 0 4.566-3.386 6.967-4.188 7.536a6.65 6.65 0 00-.116.083c-.67.556-.896.855-1.047 1.205-.184.429-.362 1.206-.362 2.902a2.5 2.5 0 01-5 0c0-1.935.184-3.517.768-4.876.616-1.432 1.559-2.345 2.491-3.115l.026-.021.027-.021c.081-.064.168-.129.257-.197.903-.685 2.145-1.626 2.145-3.496 0-1.07-.377-1.718-.833-2.124-.496-.44-1.268-.748-2.236-.748-1.084 0-1.68.287-2.035.561-.384.297-.683.736-.903 1.306a6.246 6.246 0 00-.368 1.691 6.73 6.73 0 00-.022.704l.001.018z"
        fill="#FFE249"
      />
      <path
        d="M46.2 52.665a2.332 2.332 0 110-4.663 2.332 2.332 0 010 4.663z"
        fill="#FFE249"
      />
      <path
        d="M12.04.004a1 1 0 00-.905 1.086l.34 3.761a1 1 0 001.993-.18L13.127.91a1 1 0 00-1.086-.906zM.035 10.12a1 1 0 011.228-.703l3.53.96a1 1 0 11-.524 1.93l-3.531-.96a1 1 0 01-.703-1.227zM5.81 3.265a1 1 0 00-1.538 1.28l2.78 3.341a1 1 0 001.537-1.279L5.81 3.265z"
        fill="#FFBBB3"
      />
    </g>
    <defs>
      <clipPath id="Thinking_face_Color_56_svg__clip0">
        <path fill="#fff" d="M0 0h56v56H0z" />
      </clipPath>
    </defs>
  </svg>
);

const SIZE = 56;
const CAN_SET_COLOR = false;
const SvgThinkingfaceColor56 = styled(SVG)`
  min-height: ${SIZE}px;
  min-width: ${SIZE}px;
  max-height: ${SIZE}px;
  max-width: ${SIZE}px;
  cursor: ${(p) => (p.$pointer || p.onClick ? 'pointer' : 'default')};
  ${(p) =>
    CAN_SET_COLOR &&
    css`
      path {
        fill: ${themeGet(`colors.${p.color}`, p.color)};
      }
    `}
  ${space}
`;
export default SvgThinkingfaceColor56;
